import SectionHeading from '@/pages/home/components/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { recapItems } from '@/mocks/home';

export default function RecapSection() {
  return (
    <section id="recap" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            index="01"
            kicker="BEFORE THE STORM"
            title="前情回顾：五段话讲清这件事怎么开始的"
            desc="补课的第一步不是看结论，而是先对齐起点。下面四段按时间顺序拆开，用最少的字把起因、关键节点和争议点铺好，读完你就有了完整的「前情」。"
          />
          <div className="shrink-0 rounded-lg border border-background-200 bg-background-100/70 px-5 py-4 lg:max-w-xs">
            <p className="font-label text-xs tracking-wide text-foreground-500">本期补课案例</p>
            <p className="mt-1 font-heading text-base font-bold text-foreground-950">
              《星河未眠》临阵换角风波
            </p>
            <p className="mt-1 font-body text-xs text-foreground-600">
              示例事件 · 含 5 次反转 · 持续跟进中
            </p>
          </div>
        </div>

        <ol className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {recapItems.map((item, i) => (
            <Reveal as="li" key={item.step} delay={i * 90} className="group">
              <div className="relative h-full overflow-hidden rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/60 md:p-6">
                <span className="pointer-events-none absolute right-3 top-1 font-heading text-5xl font-black text-background-300/70 md:text-6xl">
                  {item.step}
                </span>
                <span className="relative inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] font-medium text-secondary-900">
                  {item.tag}
                </span>
                <h3 className="relative mt-4 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="relative mt-3 font-body text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}